import moment from "moment";

export const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

export const getMonthsBetweenDates = (startDate, endDate) => {
    let currentDate = startDate;
    let monthsInBetween = [];
    while (moment(currentDate).isSameOrBefore(endDate, "month")) {
        monthsInBetween.push(months[moment(currentDate).month()]);
        currentDate = moment(currentDate).add(1, "month");
    }
    return monthsInBetween;
};
